import { RegisteredComponent } from "@builder.io/sdk-react";
import { generalFormConfig } from "./generalFormConfig";

export const radioInputBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Radio input",
  description:
    "The following state variables are expected: [name] for handling the value of the radio input.",
  noWrap: true,
  canHaveChildren: false,
  defaultStyles: {},
  defaults: {},
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "value",
      type: "boolean",
      localized: false,
    },
    {
      name: "onChange",
      type: "javascript",
      localized: false,
    },
    {
      name: "label",
      type: "uiBlocks",
      localized: true,
      required: false,
      defaultValue: [
        {
          "@type": "@builder.io/sdk:Element",
          children: [
            {
              "@type": "@builder.io/sdk:Element",
              component: {
                name: "Text",
                options: {
                  text: {
                    "@type": "@builder.io/core:LocalizedValue",
                    Default: "Label",
                  },
                },
              },
              meta: {
                localizedTextInputs: ["text"],
                "transformed.text": "localized",
              },
            },
          ],
        },
      ],
    },
    {
      name: "onChangeState",
      type: "javascript",
      localized: false,
    },
    ...(generalFormConfig ?? []),
  ],
};
